import { Dimensions } from 'types/dimensions';
import { PositionedLabel } from 'types/positionedLabel';

export const calculateFontScale = (newSize: Dimensions, positionedLabel: PositionedLabel): number => {
  const { size: currentSize = { width: 0, height: 0 }, fontScale: currentFontScale = 100 } = positionedLabel;
  const fontScale = (newSize.height / currentSize.height) * 100 * (currentFontScale / 100);
  return fontScale;
};
